import { useState } from "react";
import { ERROR_MESSAGES } from "../constant/constant";
import { useAxios } from "./useAxios";
import { useTenantAuth } from "../context/TeanantAuthProvider";

/**
 * Redirect user from subdomain → main domain login
 * Works for localhost & production
 */
export const redirectToMainLogin = () => {
  const { protocol, host } = window.location;
  // Stay on the same subdomain, just go to /login
  window.location.replace(`${protocol}//${host}/login`);
};

export const useTenantLogout = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const { logout } = useTenantAuth();
  const { axiosInstance } = useAxios();

  const tenantLogout = async () => {
    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      // 1️⃣ Backend logout (best effort)
      await axiosInstance.post("/tenant/auth/logout");
    } catch (err) {
      console.error("Logout API failed:", err);
      setError(err.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
    } finally {
      // 2️⃣ Clear tenant auth state
      logout();

      // 3️⃣ Hard clear (subdomain storage only)
      localStorage.clear();
      sessionStorage.clear();

      // 4️⃣ 🔥 FORCE redirect on SAME subdomain
      // window.location.replace("/login");

      setSuccess(true);
      setLoading(false);
    }
  };

  return { loading, error, success, tenantLogout };
};
